import { DataChannel } from '../../common/channels/channel';

export const projectSettingsChannel = {
  saved: new DataChannel<boolean>(),
};
